import { z } from 'zod';
import { isValidE164Phone, requiredE164PhoneSchema } from '../common/phone.js';

// --- Base Types ---
const RecipientSchema = z.union([
    z.string().email(), // Email
    z.string().refine((v) => isValidE164Phone(v), { message: 'Invalid E.164 phone' }),
    z.string(), // UserId / PushToken / WebhookURL
]);

// --- Email ---
export const EmailPayloadSchema = z.object({
    to: z.array(z.string().email()).or(z.string().email()),
    subject: z.string(),
    html: z.string(),
    text: z.string().optional(),
    from: z.string().optional(),
    attachments: z.array(z.object({
        filename: z.string(),
        content: z.any(), // Buffer or string
        contentType: z.string().optional()
    })).optional()
});

// --- SMS ---
export const SmsPayloadSchema = z.object({
    to: requiredE164PhoneSchema,
    text: z.string(),
});

// --- Push (FCM/Mobile) ---
export const PushPayloadSchema = z.object({
    tokens: z.array(z.string()).nonempty(),
    notification: z.object({
        title: z.string(),
        body: z.string(),
        imageUrl: z.string().optional(),
    }),
    data: z.record(z.string()).optional(),
});

// --- Slack / Discord (ChatOps) ---
export const ChatMessageSchema = z.object({
    channel: z.string().optional(), // Channel ID or Name
    text: z.string(),
    blocks: z.array(z.any()).optional(), // Slack blocks
    embeds: z.array(z.any()).optional(), // Discord embeds
});

// --- In-App (Notification Center) ---
export const InAppNotificationSchema = z.object({
    userId: z.string(),
    title: z.string(),
    body: z.string(),
    type: z.enum(['info', 'success', 'warning', 'error']).default('info'),
    link: z.string().optional(),
    read: z.boolean().default(false),
    metadata: z.record(z.any()).optional(),
});

// --- Webhook ---
export const WebhookPayloadSchema = z.object({
    url: z.string().url(),
    method: z.enum(['GET', 'POST', 'PUT', 'DELETE']).default('POST'),
    headers: z.record(z.string()).optional(),
    body: z.record(z.any()).optional(),
    secret: z.string().optional(), // For signature
});
